import { createSelector } from "reselect";

import map from "lodash/map";
import uniqBy from "lodash/uniqBy";

const getTextTrackEntities = (state) => state.story.entities.textTracks;

const getTextTrackLanguages = createSelector(
  [getTextTrackEntities],
  (textTrackEntities) =>
    uniqBy(
      map(textTrackEntities, (track) => ({
        srclang: track.srclang,
        label: track.label,
        default: track.default || false,
      })),
      "srclang",
    ),
);

export default getTextTrackLanguages;
